import { Module } from "vuex";
import { RootState } from "../types";
import { CustomersState } from "./types";

import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

import { Customer } from '@/models';

// Default state
export const state: CustomersState = {
	current: new Customer(),
	list: [],
	updates: [],
}

// User namespaced Vuex modules
const namespaced: boolean = true;

// Module export
const customers: Module<CustomersState, RootState> = {
	state,
	getters,
	mutations,
	actions,
	namespaced,
}

export default customers;